module.exports = __webpack_public_path__ + "static/media/twitter.e1d28756.png";